(function($, undefined)
{
    "use strict";

    Date.prototype.addHours = function(h)
    {
        this.setHours(this.getHours()+h);
        return this;
    };

    var hasLocalStorage = function()
    {
        var mod = 'hasLocalStorage';
        try {
            localStorage.setItem(mod, mod);
            localStorage.removeItem(mod);
            return true;
        } catch(e) {
            return false;
        }
    };

    var $window = $(window);

    $(document).ready(function()
    {

        /**
         * Auto save
         */
        $('.ce_form form').each(function()
        {
            // disabled
            return false;

            // check for local storage
            if (!hasLocalStorage())
            {
                return false;
            }

            var $form = $(this);
            var formId = $form.attr('id');

            if (formId === undefined)
            {
                return true;
            }

            var formStorage = 'autosave-' + formId;

            var saveFormData = function()
            {
                var storageData = JSON.stringify({
                    expire: new Date().addHours(1),
                    data: $form.serializeArray()
                });

                localStorage.setItem(formStorage, storageData);

                return true;
            };

            var loadFormData = function()
            {
                var storageItem = localStorage.getItem(formStorage);

                if (null !== storageItem)
                {
                    storageItem = JSON.parse(storageItem);

                    if (new Date() < new Date(storageItem.expire))
                    {
                        return storageItem.data;
                    }
                }

                return undefined;
            };

            var eraseFormData = function()
            {
                localStorage.removeItem(formStorage);
                return true;
            };


            // load form data
            var previousFormData = loadFormData();
            if (previousFormData !== undefined)
            {
                $.each(previousFormData, function(index, item)
                {
                    $form.find('input, textarea, select').filter('[name="' + item.name + '"]').not('[type="hidden"]').each(function()
                    {
                        var $input = $(this);
                        var $radioCheckboxSelect = $input.filter('[type="radio"], [type="checkbox"], select');
                        var $textInput = $input.not('[type="radio"], [type="checkbox"], select');

                        // don't do anything if there is already a value on text input
                        if ($textInput.val())
                        {
                            return true;
                        }

                        if ($radioCheckboxSelect.length > 0)
                        {
                            if (item.value)
                            {
                                var $inputValue = $input.filter('[value="' + item.value + '"]');
                                if ($inputValue.length > 0)
                                {
                                    $inputValue.prop('checked', true).prop('selected', true).change();
                                    return false;
                                }

                                var $option = $input.find('[value="' + item.value + '"]');
                                if ($option.length > 0)
                                {
                                    $option.prop('checked', true).prop('selected', true).change();
                                    return false;
                                }

                                return true;
                            }
                        }
                        else
                        {
                            $input.val(item.value);
                            return false;
                        }
                    });
                });
            }


            // save form data
            var timeoutId;
            $form.find('input, textarea, select').on('change propertychange input', function()
            {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(saveFormData, 1000);
            });
        });

        var textAreaSingleRow;

        /**
         * Auto grow text areas
         */
        function autoresize(textarea)
        {
            if ($(textarea).is(':visible'))
            {
                textarea.style.minHeight = '0px';
                textarea.style.minHeight = textarea.scrollHeight + 'px';

                if(!textAreaSingleRow) {
                    textAreaSingleRow = textarea.scrollHeight;
                }

                var initialRows = 3;
                // preserver min height of initialRows rows (initialRows x scroll height)
                if (parseInt(textarea.style.minHeight) < (textarea.scrollHeight * initialRows)) {
                    var fiveRows = textAreaSingleRow * initialRows;
                    if (textarea.scrollHeight < fiveRows) {
                        textarea.style.minHeight = fiveRows + 'px';
                    } else {
                        textarea.style.minHeight = textarea.scrollHeight + 'px';
                    }
                }
            }
        }
        $('textarea').each(function()
        {
            autoresize(this);
            $(this).keyup(function(event) {
                autoresize(this);
            });
        });


        /**
         * Focus of widgets
         */
        $('form .widget').each(function()
        {
            var $widget = $(this);
            $widget.find('input:not([type="checkbox"]):not([type="radio"]),select,textarea').each(function() {
                var $input = $(this);
                if ($input.val() != '' || $input.attr('placeholder')) {
                    $widget.addClass('move-label');
                }
            }).focus(function() {
                $widget.addClass('move-label'); 
            }).focusout(function() {
                var $input = $(this);
                if ($input.val() == '' && !$input.attr('placeholder')) {
                    $widget.removeClass('move-label');
                }
            });
        });


        /**
         * Chosen class for radio and checkbox
         */
        $('form .widget-radio, form .widget-checkbox').each(function()
        {
            var $widget = $(this);
            var $inputs = $widget.find('input');
            var updateChosen = function()
            {
                if ($inputs.is(':checked'))
                {
                    $widget.addClass('chosen');
                }
                else
                {
                    $widget.removeClass('chose');
                }  
            };
            updateChosen();
            $inputs.on('change', updateChosen);
        });


        /**
         * Custom Radio Value
         */
        $('.widget-radio-custom').each(function() {
            $('input[type="text"]').focus(function() {
                $(this).siblings('input[type="radio"]').prop('checked', true);
            });
        });


        /**
         * Validate form
         */
        $('form').each(function()
        {
            var $form = $(this);
            var $inputs = $form.find('input,select,textarea');

            var change = function()
            {
                $form.addClass('valid');
                $inputs.each(function()
                {
                    this.checkValidity();
                });
            };

            $inputs.on('input', change)
                   .on('change', change)
                   .bind('invalid', function()
            {
                $form.removeClass('valid');
            });
        });

        /**
         * Range slider - old (min / max not working)
         */
/*
        $('.widget-range').each(function() {
            var $widget = $(this);
            var $range = $widget.find('input[type="range"]');
            var $input = $widget.find('input[type="number"]');
            var step = 1;

            if (typeof $range.attr('step') !== 'undefined') {
                step = parseFloat($range.attr('step'));
            }

            $widget.find('.quantity--up').on('click', function() {
                $input.val(parseFloat($input.val()) + step);
                $input.blur();
            });

            $widget.find('.quantity--down').on('click', function() {
                $input.val(parseFloat($input.val()) - step);
                $input.blur();
            });

            $range.on('input', function() {
                $input.val($range.val());
            });

            $input.on('blur', function() {
                var value = parseFloat($input.val());
                var mult = Math.round(value / step);
                value = step * mult;

                if (typeof $range.attr('min') !== 'undefined') {
                    var min = parseFloat($range.attr('min'));
                    if (value < min) {
                        value = min;
                    }
                }

                if (typeof $range.attr('max') !== 'undefined') {
                    var max = parseFloat($range.attr('max'));
                    if (value > max) {
                        value = max;
                    }
                }

                $range.val(value);
                $input.val(value);
            });
        });
*/
        /**
         * Range slider - new (min / max working with CSS class workaround)
         */
        $('.widget-range').each(function() {
            function formatNumber(number, options) {
                var result = (options['fraction'] ? number.toFixed(options['fraction']) :
                    '' + number).split('.');
                return options['prefix'] +
                    result[0].replace(/\B(?=(\d{3})+(?!\d))/g, (options['grouping'])) +
                    (result[1] ? options['decimal'] + result[1] : '') +
                    options['suffix'];
            }

            var $widget = $(this);
            var $range = $widget.find('input[type="range"]');
            var $input = $widget.find('input[type="number"]');
            var step = 1;
            var regexMin = new RegExp('kontractory-input-range-slider-min-');
            var regexMax = new RegExp('kontractory-input-range-slider-max-');

            $input.attr('pattern', '^\\$\\d{1,3}(,\\d{3})*(\\.\\d+)?$');

            var classList = $input.attr('class').split(/\s+/);
            classList.forEach(function(val) {
                if(regexMin.test(val)) {
                    $input.attr('min', parseInt(val.match(/[0-9]+/)[0]));
                    $range.attr('min', parseInt(val.match(/[0-9]+/)[0]));
                }

                if(regexMax.test(val)) {
                    $input.attr('max', parseInt(val.match(/[0-9]+/)[0]));
                    $range.attr('max', parseInt(val.match(/[0-9]+/)[0]));
                }
            });

            if (typeof $range.attr('step') !== 'undefined') {
                step = parseInt($range.attr('step'), 10);
            }

            $widget.find('.quantity--up').on('click', function() {
                $input.val(parseInt($input.val().replace(/\./g, "").replace(/,/g, "."), 10) + step);
                $input.blur();
            });

            $widget.find('.quantity--down').on('click', function() {
                $input.val(parseInt($input.val().replace(/\./g, "").replace(/,/g, "."), 10) - step);
                $input.blur();
            });

            $range.on('input', function() {
                $input.val($range.val());
            });

            $input.on('blur', function() {
                var value = parseInt($input.val().replace(/\./g, "").replace(/,/g, "."), 10);
                var mult = Math.round(value / step);
                value = step * mult;

                if (typeof $range.attr('min') !== 'undefined') {
                    var min = parseInt($range.attr('min'), 10);
                    if (value < min) {
                        value = min;
                    }
                }

                if (typeof $range.attr('max') !== 'undefined') {
                    var max = parseInt($range.attr('max'), 10);
                    if (value > max) {
                        value = max;
                    }
                }

                $range.val(value);
                $input.val(value);
            });
        });

        /**
         * Toggle
         */
        $('.widget-radio.radio-toggle').each(function() {
            var $widget = $(this);
            var $labels = $widget.find('label');
            $labels.click(function(e) {
                e.preventDefault();
                $widget.find('input').not(':checked').prop("checked", true);
                return false;
            });
        });
    });

})(jQuery);
